import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Modal } from "react-bootstrap";
import SuccessIcon from "../../../styles/img/svg/SuccessIcon";
import WarningIcon from "../../../styles/img/svg/WarningIcon";
import ErrorIcon from "../../../styles/img/svg/ErrorIcon";
import { hideAjaxSuccess } from "../../../_redux/_actions";
import { authConstants } from "../../../_redux/_constants";

export default function UiSuccessAlertBox(props) {
    const actionDispatch = useDispatch();

    const { successMessage } = useSelector((state) => {
        return {
            successMessage: state.successMessage,
        };
    });

    const [show, setShow] = useState(true);
    const handleClose = () => setShow(false);

    const hideAlert = () => {
        actionDispatch(hideAjaxSuccess());
    };

    return (
        <>
            <Modal
                show={
                    successMessage.identity !=
                        authConstants.FORGOT_PASSWORD_EMAIL_VERIIFICATION_COMPLETE &&
                    successMessage.identity !=
                        authConstants.FORGOT_PASSWORD_RESET_PASSWORD_COMPLETE &&
                    successMessage.identity !=
                        authConstants.PRE_REGISTRATION_ACTIVATE_COMPLETE &&
                    successMessage.show
                }
                onHide={hideAlert}
                className="sb-alert-modal"
            >
                <Modal.Header closeButton> </Modal.Header>
                <Modal.Body>
                    <SuccessIcon />
                    <h3>{successMessage.messages[0]}</h3>
                </Modal.Body>
            </Modal>
        </>
    );
}
